import { InjectorService } from '@tencent/ioc';
import { MiddlewareRegistry } from '../../registries/middleware-registry.js';

/**
 * Middleware 装饰器，用于声明一个 UI 控制中间件
 * 其装饰的类必须实现 IMiddleware 接口
 *
 * @public
 * @decorator
 */
function Middleware(options = {}) {
    return function (target) {
        MiddlewareRegistry.merge(target, options);
        InjectorService.service(target, Object.assign(Object.assign({}, (options || {})), { type: 'middleware' }));
        InjectorService.invokable(target);
        return target;
    };
}

export { Middleware };
//# sourceMappingURL=middleware.js.map
